"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operator = void 0;
const value_wrappers_1 = require("../value-wrappers");
const operators = {
    "Multiply": {
        symbol: '×',
        operatorFn: (a, b) => a * b,
    },
    "Divide": {
        symbol: '÷',
        operatorFn: (a, b) => a / b,
    },
    "Add": {
        symbol: '+',
        operatorFn: (a, b) => a + b,
    },
    "Subtract": {
        symbol: '−',
        operatorFn: (a, b) => a - b,
    },
};
function operator(opName) {
    const op = operators[opName];
    return op ? (0, value_wrappers_1.makeValue)(op) : (0, value_wrappers_1.makeError)(`The selected operator is missing or invalid.`);
}
exports.operator = operator;
